
































import {Component, Inject, Prop, Vue} from 'vue-property-decorator';

import {Photo} from '@/model/api';
import {Estimate, RotationAngle} from '@/model/Estimate';

@Component({})
export default class PhotoControl extends Vue {
    @Inject()
    public readonly model: Estimate;

    @Prop({type: Object, required: true})
    public readonly photo: Photo;

    @Prop({type: Boolean, required: true})
    public readonly isFirst: boolean;

    @Prop({type: Boolean, required: true})
    public readonly isLast: boolean;

    public descriptionEdit: boolean = false;

    public editedDescription: string = '';

    public canChangePhotoPosition = this.model.changePhotoPosition !== undefined;

    @Prop({type: Boolean, required: true})
    public readonly processing: boolean;

    public rotate(angle: RotationAngle): void {
        if (this.model.rotatePhoto === undefined) {
            throw new Error('Estimate does not support photo rotation');
        }

        this.model.rotatePhoto(this.photo.id, angle)
            .then(this.reloadPhoto);
    }

    public editDescription(): void {
        this.descriptionEdit = true;

        this.$nextTick(function() {
            const field = this.$refs.descriptionInput as HTMLInputElement;
            field.focus();
        });
    }

    public saveDescription(): void {
        if (this.model.changePhotoDescription === undefined) {
            throw new Error('Estimate does not support photo description change');
        }

        this.model.changePhotoDescription(this.photo.id, this.editedDescription)
            .then(() => {
                this.photo.description = this.editedDescription;
                this.descriptionEdit = false;
            });
    }

    public remove(): void {
        if (this.model.removePhoto === undefined) {
            throw new Error('Estimate does not support photo removal');
        }

        if (window.confirm(this.$tc('form.photos.removeConfirmation'))) { // We may consider bootstrap modal in future
            this.model.removePhoto(this.photo.id)
                .then(() => this.$emit('removed'));
        }
    }

    protected created(): void {
        this.editedDescription = this.photo.description;
    }

    private reloadPhoto(): void {
        const photoUrl = new URL(this.photo.url);

        photoUrl.searchParams.append('t', '' + Date.now());
        this.photo.url = photoUrl.toString();
    }
}
